module.exports = __webpack_public_path__ + "img/pdf_logo_yellow.adcad6f8.png";